// Live Golden Atom Core: a compact SVG animation that renders a pulsing
// gold nucleus plus three particle orbits rotating on independent axes.
// Pure CSS animation (transform on grouped SVG elements) so no runtime
// cost on the main thread. Sized 24 to 48 px depending on the caller.
//
// Colors follow the brand palette: brushed gold (#D4AF37) core + champagne
// (#FFF8E1) particles. Emits a soft glow so it bleeds into the surrounding
// frosted glass panel.

import "./AtomCore.css";

export default function AtomCore({ size = 32, className = "", testId }) {
  const s = size;
  return (
    <div
      className={`atom-core ${className}`}
      style={{ width: s, height: s }}
      data-testid={testId}
      aria-hidden
    >
      <svg viewBox="0 0 100 100" width={s} height={s} className="atom-core-svg">
        {/* Ambient halo behind the atom. Blurred gold radial. */}
        <defs>
          <radialGradient id="atom-core-halo" cx="50%" cy="50%" r="50%">
            <stop offset="0%"  stopColor="#FFF8E1" stopOpacity="0.75" />
            <stop offset="45%" stopColor="#D4AF37" stopOpacity="0.35" />
            <stop offset="100%" stopColor="#D4AF37" stopOpacity="0" />
          </radialGradient>
          <radialGradient id="atom-core-nucleus" cx="40%" cy="35%" r="65%">
            <stop offset="0%"  stopColor="#FFF8E1" />
            <stop offset="45%" stopColor="#F5D97C" />
            <stop offset="100%" stopColor="#8A6B1A" />
          </radialGradient>
        </defs>

        {/* Halo. Pulses to give the whole mark a heartbeat. */}
        <circle cx="50" cy="50" r="48" fill="url(#atom-core-halo)" className="atom-core-halo" />

        {/* Three orbital ellipses, each rotating around a different axis. */}
        <g className="atom-core-orbit atom-core-orbit-a">
          <ellipse cx="50" cy="50" rx="36" ry="14" fill="none" stroke="#D4AF37" strokeWidth="1" strokeOpacity="0.55" />
          <circle cx="86" cy="50" r="3.6" fill="#FFF8E1" className="atom-core-particle" />
        </g>
        <g className="atom-core-orbit atom-core-orbit-b">
          <ellipse cx="50" cy="50" rx="36" ry="14" fill="none" stroke="#D4AF37" strokeWidth="1" strokeOpacity="0.55" />
          <circle cx="14" cy="50" r="3.2" fill="#FFF8E1" className="atom-core-particle" />
        </g>
        <g className="atom-core-orbit atom-core-orbit-c">
          <ellipse cx="50" cy="50" rx="36" ry="14" fill="none" stroke="#D4AF37" strokeWidth="1" strokeOpacity="0.55" />
          <circle cx="86" cy="50" r="3" fill="#FFF8E1" className="atom-core-particle" />
        </g>

        {/* Golden nucleus. Pumps like a heart. */}
        <circle
          cx="50"
          cy="50"
          r="10"
          fill="url(#atom-core-nucleus)"
          className="atom-core-nucleus"
        />
      </svg>
    </div>
  );
}
